module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-chef u-pad-a-1"
  }, [_c('div', {
    staticClass: "p-chef__container u-marg-x-auto u-flex u-flex-fd--column u-w8of10"
  }, [(_vm.$root.isTouch || _vm.$root.width <= _vm.$root.CONSTANTS.breakpoints.xs) ? _c('div', _vm._l((_vm.content.blocks), function(block, index) {
    return _c('div', {
      staticClass: "p-chef__container__block u-flex u-flex-fd--column@xs u-fit-w"
    }, [_vm._l((block.images), function(item, i) {
      return _c('div', {
        staticClass: "p-chef__container__images__item u-w3of8 u-fit-w@xs u-overflow-h",
        class: [i === 0 ? 'is-first' : '']
      }, [_c('app-scroll-object', {
        attrs: {
          "is-parallax": true,
          "parallax-ratio": 0.03,
          "content": {
            image: item.image
          }
        },
        inlineTemplate: {
          render: function() {
            var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
              return _c('div', {
                staticClass: "u-overflow-h"
              }, [_c('img', {
                staticClass: "u-fit-w",
                attrs: {
                  "src": _vm.content.image.sizes['600x0'],
                  "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons',
                  "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons'
                }
              })])
            
          },
          staticRenderFns: []
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "u-hide u-opacity--0",
        staticStyle: {
          "height": "'1px'",
          "width": "'1px'",
          "visibility": "'hidden'"
        },
        attrs: {
          "src": item.image.sizes['600x0'],
          "alt": item.image.caption ? item.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons',
          "title": item.image.caption ? item.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons'
        },
        on: {
          "load": _vm._onLoadMedia
        }
      })], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "p-chef__container__content u-w5of8 u-fit-w@xs"
    }, _vm._l((block.texts), function(block, i) {
      return _c('div', {
        staticClass: "p-chef__container__content__block u-fit-w",
        class: ['p-chef__container__content__block--' + block.type, i === 0 ? 'is-first' : '']
      }, [(block.type === _vm.$root.CONSTANTS.chefBlockTypes.TITLE) ? _c('h2', [_c('span', {
        staticClass: "t-ffamily--domaine t-fweight--light t-text--xxl u-uppercase",
        domProps: {
          "innerHTML": _vm._s(block.content)
        }
      })]) : _vm._e(), _vm._v(" "), (block.type === _vm.$root.CONSTANTS.chefBlockTypes.SUBTITLE) ? _c('h3', [_c('span', {
        staticClass: "t-ffamily--domaine t-fweight--light t-text--sm",
        domProps: {
          "innerHTML": _vm._s(block.content)
        }
      })]) : _vm._e(), _vm._v(" "), (block.type === _vm.$root.CONSTANTS.chefBlockTypes.BLOCKQUOTE) ? _c('blockquote', [_c('span', {
        staticClass: "t-ffamily--domaine t-fweight--light t-text--lg",
        domProps: {
          "innerHTML": _vm._s(block.content)
        }
      })]) : _vm._e(), _vm._v(" "), (block.type === _vm.$root.CONSTANTS.chefBlockTypes.TEXT) ? _c('p', [_c('span', {
        staticClass: "t-ffamily--domaine t-fweight--light t-text--sm-lh u-opacity--40",
        domProps: {
          "innerHTML": _vm._s(block.content)
        }
      })]) : _vm._e()])
    }))], 2)
  })) : (!_vm.$root.isTouch && _vm.$root.width > _vm.$root.CONSTANTS.breakpoints.xs) ? _c('div', {
    staticClass: "p-chef__container__blocks u-flex u-flex-jc--space-between u-fit-w"
  }, [_c('div', {
    staticClass: "u-w3of8"
  }, _vm._l((_vm.images), function(item, i) {
    return _c('div', {
      staticClass: "p-chef__container-desktop__images__item u-marg-t- u-fit-w u-overflow-h",
      class: [i === 0 ? 'is-first' : '']
    }, [_c('app-scroll-object', {
      attrs: {
        "is-parallax": true,
        "parallax-ratio": 0.05,
        "content": {
          image: item.image
        }
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', {
              staticClass: "u-overflow-h"
            }, [_c('img', {
              staticClass: "u-fit-w",
              attrs: {
                "src": _vm.content.image.sizes['600x0'],
                "alt": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons',
                "title": _vm.content.image.caption ? _vm.content.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons'
              }
            })])
          
        },
        staticRenderFns: []
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "u-hide u-opacity--0",
      staticStyle: {
        "height": "'1px'",
        "width": "'1px'",
        "visibility": "'hidden'"
      },
      attrs: {
        "src": item.image.sizes['600x0'],
        "alt": item.image.caption ? item.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons',
        "title": item.image.caption ? item.image.caption + ' - ' + 'Four Seasons' : 'Four Seasons'
      },
      on: {
        "load": _vm._onLoadMedia
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "p-chef__container__content u-w5of8"
  }, _vm._l((_vm.texts), function(block, i) {
    return _c('div', {
      staticClass: "p-chef__container__content__block u-fit-w",
      class: ['p-chef__container__content__block--' + block.type, i === 0 ? 'is-first' : '']
    }, [(block.type === _vm.$root.CONSTANTS.chefBlockTypes.TITLE) ? _c('h2', [_c('span', {
      staticClass: "t-ffamily--domaine t-fweight--light t-text--xxl u-uppercase",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    })]) : _vm._e(), _vm._v(" "), (block.type === _vm.$root.CONSTANTS.chefBlockTypes.SUBTITLE) ? _c('h3', [_c('span', {
      staticClass: "t-ffamily--domaine t-fweight--light t-text--sm",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    })]) : _vm._e(), _vm._v(" "), (block.type === _vm.$root.CONSTANTS.chefBlockTypes.BLOCKQUOTE) ? _c('blockquote', [_c('span', {
      staticClass: "t-ffamily--domaine t-fweight--light t-text--lg",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    })]) : _vm._e(), _vm._v(" "), (block.type === _vm.$root.CONSTANTS.chefBlockTypes.TEXT) ? _c('p', [_c('span', {
      staticClass: "t-ffamily--domaine t-fweight--light t-text--sm-lh u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    })]) : _vm._e()])
  }))]) : _vm._e()]), _vm._v(" "), _c('app-page-footer', {
    attrs: {
      "text": _vm.content.footer_text_content,
      "page": _vm.content.footer_page,
      "link-label": _vm.content.footer_label_discover_restaurants
    }
  }), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ced9b0"}!./src/scripts/components/page-chef/template.html
// module id = 190
// module chunks = 0